




























































































































































import { Component, Vue } from 'vue-property-decorator'
import { Order } from '@/api/model/order'
import { OrderCount } from '@/api/model/order-count'
import { isEqual } from 'lodash'
import { namespace } from 'vuex-class'
const orders = namespace('orders')

@Component
export default class OrderList extends Vue {
    @orders.State readonly loading!: boolean
    @orders.State readonly orders!: Order[]
    @orders.State readonly view!: string
    @orders.State readonly direction!: string
    @orders.State readonly orderField!: string|null
    @orders.State readonly orderDirection!: string|null
    @orders.State readonly orderCounts!: OrderCount
    @orders.State readonly statusFilter!: string
    @orders.State readonly totalPages!: number
    @orders.State readonly page!: number
    @orders.State readonly dateSpecificFilter!: Date
    @orders.State readonly dateRangeFilter!: string
    @orders.State readonly totalItems!: string
    @orders.State readonly search!: string|null
    @orders.State readonly itemsPerPage!: number
    @orders.Action nextPage: () => Promise<void>
    @orders.Action prevPage: () => Promise<void>
    @orders.Action applyView: ({ view: ReferralView, direction: ReferralFilterDirection }) => Promise<void>
    @orders.Action applyOrder: ({ field, direction }) => Promise<void>
    @orders.Action applyStatusFilter: ({ statusFilter: string }) => Promise<void>
    @orders.Action applyDateSpecificFilter: ({ day: Date }) => Promise<void>
    @orders.Action applyDateRangeFilter: ({ range: string, update: boolean }) => Promise<void>
    @orders.Action resetFilters: () => Promise<void>
    @orders.Action applySearch: ({ query }) => Promise<void>
    @orders.Action snapshot: () => Promise<void>
    @orders.Action setItemsPerPage: ({ itemsPerPage: number }) => Promise<void>
    @orders.Getter activeFilterCount: number
    @orders.Getter activeFilters: string[]
    showingFilters: boolean = false
    searchTimeout: NodeJS.Timeout = null

    async created(): Promise<void> {
        // Set a default if no view is set.
        if (this.view === null) {
            await this.applyView({
                view: 'user',
                direction: 'in',
            })
        }

        // Snapshot currently set filters.
        await this.snapshot()

        this.showingFilters = this.activeFilterCount > 0
    }

    onDateRangeChanged(value: string): void {
        if (isEqual(this.dateRangeFilter, value)) {
            return
        }

        this.applyDateRangeFilter({
            range: value,
            update: true,
        })
    }

    onSearchChange(query: string) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => this.applySearch({ query }), 400)
    }

    onItemsPerPageInput(itemsPerPage: number) {
        if (isEqual(this.itemsPerPage, itemsPerPage)) {
            return
        }

        this.setItemsPerPage({ itemsPerPage })
    }

    changeOrder(field: string, direction: string) {
        if (this.orderField === field) {
            direction = this.orderDirection === 'asc' ? 'desc' : 'asc'

        } else {
            direction = 'desc'
        }

        this.applyOrder({
            field,
            direction,
        })
    }

    generateHeaderClasses(field: string) {
        return {
            'sortable': true,
            'sorted': this.orderField === field,
            'sorted--asc': this.orderField === field && this.orderDirection === 'asc',
            'sorted--desc': this.orderField === field && this.orderDirection === 'desc',
        }
    }

    toggleFilters(): void {
        this.showingFilters = !this.showingFilters
    }

    get itemsPerPageOptions(): Array<{ label: string, value: number }> {
        return [10, 25, 50, 75, 100].map(value => {
            return {
                label: value.toString(),
                value,
            }
        })
    }

    get dateRangeOptions() {
        return [
            { label: this.$t('referral-list.dateRange.all').toString(), value: null },
            { label: this.$t('referral-list.dateRange.week').toString(), value: 'week' },
            { label: this.$t('referral-list.dateRange.month').toString(), value: 'month' },
            { label: this.$t('referral-list.dateRange.year').toString(), value: 'year' },
            { label: this.$t('referral-list.dateRange.thisWeek').toString(), value: 'this-week' },
            { label: this.$t('referral-list.dateRange.thisMonth').toString(), value: 'this-month' },
            { label: this.$t('referral-list.dateRange.thisYear').toString(), value: 'this-year' },
        ]
    }

    get viewLabel(): string {
        return this.$t('order_list.no_result.' + this.view +  '.label').toString()
    }

    get directionLabel(): string {
        return this.$t('order_list.no_result.' + this.view + '.' + this.direction).toString()
    }

    get componentClasses() {
            return {
                'orders': true,
                'orders--beta-one': this.$currentUser?.betaOptInEnabled,
            }
        }
}
